import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthWrapper = ({ onLogin, onRegister, error, supabase }) => {
  const [isLogin, setIsLogin] = useState(true);

  const handleSwitchToRegister = () => {
    setIsLogin(false);
  };

  const handleSwitchToLogin = () => {
    setIsLogin(true);
  };

  return (
    <div className="transition-all duration-500 ease-in-out">
      {isLogin ? (
        <div className="animate-in slide-in-from-top-5">
          <LoginForm 
            onLogin={onLogin} 
            onSwitchToRegister={handleSwitchToRegister}
            error={error} 
          />
        </div>
      ) : (
        <div className="animate-in slide-in-from-bottom-5">
          <RegisterForm 
            onRegister={onRegister} 
            onSwitchToLogin={handleSwitchToLogin}
            error={error} 
            supabase={supabase}
          />
        </div>
      )}
    </div>
  );
};

export default AuthWrapper;